// React
import React, { Fragment } from 'react';
// Material-UI

// Otras libs

// Componentes

// Vistas

// Servicios

// Funciones

// Hooks


/**
 * 
 * @typedef {Object} Props
 * @property {string} titulo Titulo de sección
 * @property {bool} visible Si se debe mostrar
 * @property {React.ReactNode} icon Icono de sección
 */

/**
 * Sección
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns 
 */
export const Seccion = ({ 
    titulo = '',
    visible = true,
    icon = undefined,
    children,
}) => {
    // Idioma
    
    // Estados
    
    // Listas

    // Vista
    return (
        <Fragment>{children}</Fragment>
    );
};
